import { OnInit, Component, ViewChild, ElementRef, ChangeDetectorRef, ViewEncapsulation } from '@angular/core';
import { UntypedFormGroup, UntypedFormControl, Validators } from '@angular/forms';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { ImageService } from '../../core/services/image.service';
import { DeleteAccountComponent } from '../../shared/components/delete-account/delete-account.component';
import { LoginService } from 'src/app/core/services/login.service';
import { AfipModel } from 'src/app/core/models/afip.model';
import { TranslateService } from '@ngx-translate/core';
import { GenericPlace } from 'src/app/core/models/generic-place.model';
import { CommerceForm } from 'src/app/core/models/interfaces/forms/commerce.form';
import { OrganismModel } from 'src/app/core/models/organism.model';
import { AfipService } from 'src/app/core/services/afip.service';
import { NotificationService } from 'src/app/core/services/notification.service';
import { UserService } from 'src/app/core/services/user.services';
import { DialogAfipComponent } from 'src/app/shared/components/dialog-afip/dialog-afip.component';
import { finalDotVerificator, validateCuit } from 'src/app/shared/functions/afip.functions';
import { IOptionsNgSelect } from 'src/app/shared/interfaces/ioptionsNgSelect';
import { DialogCommerceComponent } from 'src/app/shared/components/dialog-commerce/dialog-commerce.component';
import { User } from 'src/app/core/models/user';
import { IdentityService } from 'src/app/core/services/identity.service';
import { BalanceService } from 'src/app/core/services/balance.service';
import { TarifarioService } from '../../core/services/tarifario.service';
import { datosPersonalModel } from 'src/app/core/models/datos-personales.model';
import { SearchPlaceComponent } from './components/search-place/search-place.component';
import { TermsAndConditionsDialogComponent } from 'src/app/shared/components/terms-and-conditions-dialog/terms-and-conditions-dialog.component';
import { NativeBridgeService } from 'src/app/core/services/native-bridge.service';
import { deviceEnvironmentId } from 'src/app/core/enums/device-environment-id';
import { RolesWeb } from 'src/app/core/enums/roles.enum';

@Component({
  selector: 'app-my-commerce',
  templateUrl: './my-commerce.component.html',
  styleUrls: ['./my-commerce.component.scss']
})
export class MyCommerceComponent implements OnInit {
  private readonly DOMICILIO_COMERCIAL: string = 'domicilioComercial';
  readonly TIPO_CASA: string = 'casa';
  readonly TIPO_DEPARTAMENTO: string = 'departamento';

  checked = false;
  wantToBeOrganismo = false;
  @ViewChild(SearchPlaceComponent) searchPlace: SearchPlaceComponent;
  @ViewChild('txtToken') txtToken: ElementRef;

  myform: UntypedFormGroup;
  form: UntypedFormGroup;
  currentUser: User;
  datosPersonales: datosPersonalModel;
  private organism: OrganismModel;
  selected: number;
  condicionIVA: string;
  isComplete: boolean;
  fechaNacimientoModel: Date;
  isCuitOk: boolean = true;
  loadingProfile: boolean = false;
  searchingCuit: boolean = false;
  selectHomeType: string = this.TIPO_CASA;
  dialogCommerce: MatDialogRef<DialogCommerceComponent>;
  saving: boolean = false;
  placeChanged: boolean = false;
  rol: any;

  esDepartamento: boolean = false;

  registryState: RegistryInformation;

  profilePictureUrl = 'assets/images/user_guest.png';
  uploadingProfilePicture = false;
  ivaConditionsCollection: { value: number; display: string }[];

  //#region USER-DATA

  get userName(): string {
    return this.currentUser.persona?.nombres;
  }

  get userLastName(): string {
    return this.currentUser.persona?.apellido;
  }

  get userEmail(): string {
    return this.currentUser.email;
  }

  get userDocument(): string {
    if (this.currentUser.persona?.nroDocumento != null) {
      return this.currentUser.persona?.nroDocumento.toString();
    } else {
      return '-';
    }
  }

  get userPhone(): string {
    return this.currentUser.persona?.telefono ? this.currentUser.persona?.telefono : '-';
  }

  get userCuitCuil(): string {
    return this.currentUser.persona?.cuilCuit;
  }

  get userBirth(): string {
    if (this.userDocument === null || this.userDocument == '0' || this.currentUser.persona?.fechaNacimiento == null) {
      return '-';
    }
    return new Date(this.currentUser.persona?.fechaNacimiento).toLocaleDateString();
  }

  userCVUAlias: string;
  userCVU: string;
  afipData: AfipModel;
  locationData: GenericPlace;
  visibility: boolean = true;
  valueToken: string;
  hasApiToken: boolean = false;
  rowTxt: number = 1;
  loggedUser: User;
  //#endregion USER-DATA

  //#region CUIT HANDLERS

  displayCuitErrorMessage: boolean = false;
  cuitReadonly: boolean = false;

  //#endregion CUIT HANDLERS

  get formControls() {
    return this.form.controls;
  }

  get domicilioComercial() {
    return this.form.controls.domicilioComercial;
  }
  get bancoForm() {
    return this.form.controls.bancoForm;
  }
  get comercioNombre() {
    return this.form.controls.comercioNombre;
  }
  get domicilioFiscal() {
    return this.form.controls.domicilioFiscal;
  }
  get comercioRS() {
    return this.form.controls.comercioRS;
  }
  get condicionIVAform() {
    return this.form.controls.condicionIVA;
  }
  get comercioCuit() {
    return this.form.controls.comercioCuit;
  }
  get comercioRubro() {
    return this.form.controls.comercioRubro;
  }

  get userHasPersona(): boolean {
    let response = false;
    if (this.currentUser.persona) {
      response = true;
    }
    return response;
  }

  get userHasOrganism(): boolean {
    return this.organism != null;
  }

  get organismHasNoLogo() {
    return this.organism != null && this.profilePictureUrl == null;
  }

  get serviceName(): string {
    let response = null;
    if (this.organism.servicioList) {
      let [service] = this.organism.servicioList;
      response = service.nombre;
    }
    return response;
  }

  get userValidate(): boolean {
    return this.currentUser.statusRegistro.completo;
  }

  get organismId(): number | null {
    if (this.userHasOrganism) {
      return this.organism.id;
    }
    return null;
  }

  //#region RUBRO SECTION

  rubroOptionsCollection: IOptionsNgSelect[];

  //#endregion RUBRO SECTION

  isMobile: boolean;

  translate(key: string, paramKey?: string): string {
    let param = {};
    if (paramKey) {
      param = { campo: this.translateService.instant(paramKey) };
    }
    return this.translateService.instant(key, param);
  }

  constructor(
    private identity: IdentityService,
    private userService: UserService,
    private notificationService: NotificationService,
    private dialog: MatDialog,
    private afipService: AfipService,
    private imageService: ImageService,
    private login: LoginService,
    private translateService: TranslateService,
    private ref: ChangeDetectorRef,
    private router: Router,
    private balanceService: BalanceService,
    private tarifarioService: TarifarioService,
    private nativeBridgeService: NativeBridgeService
  ) {
    this.ivaConditionsCollection = [
      { value: 1, display: this.translate('pages.profile.labels.iva.opt_1') },
      { value: 2, display: this.translate('pages.profile.labels.iva.opt_2') },
      { value: 3, display: this.translate('pages.profile.labels.iva.opt_3') },
      { value: 4, display: this.translate('pages.profile.labels.iva.opt_4') },
      { value: 5, display: this.translate('pages.profile.labels.iva.opt_5') }
    ];
    this.isMobile =
      this.nativeBridgeService.getEnvironment() == deviceEnvironmentId.ANDROID ||
      this.nativeBridgeService.getEnvironment() == deviceEnvironmentId.IOS ||
      this.nativeBridgeService.getEnvironment() == deviceEnvironmentId.CLOVER;
    this.form = new UntypedFormGroup({
      comercioNombre: new UntypedFormControl('', Validators.compose([Validators.maxLength(255), Validators.required])),
      domicilioComercial: new UntypedFormControl(
        '',
        Validators.compose([Validators.maxLength(255), Validators.required])
      ),
      comercioRS: new UntypedFormControl('', Validators.compose([Validators.maxLength(255), Validators.required])),
      comercioCuit: new UntypedFormControl('', Validators.compose([Validators.maxLength(11), Validators.required])),
      domicilioFiscal: new UntypedFormControl('', Validators.compose([Validators.maxLength(255), Validators.required])),
      condicionIVA: new UntypedFormControl('', Validators.required),
      comercioRubro: new UntypedFormControl(''),
      bancoForm: new UntypedFormControl('', Validators.compose([Validators.minLength(6), Validators.maxLength(22)])),
      apiToken: new UntypedFormControl(''),
      departamentoPiso: new UntypedFormControl(''),
      departamentoNumero: new UntypedFormControl(''),
      descipcionOptional: new UntypedFormControl(''),
      tipoCasa: new UntypedFormControl(''),
      rubro: new UntypedFormControl('', Validators.required)
    });
    this.registryState = <RegistryInformation>{};
    this.afipData = new AfipModel();
    this.rubroOptionsCollection = new Array<IOptionsNgSelect>();
  }
  isGenerated: boolean = false;
  //TODO notificaciones a la hora de error
  async ngOnInit() {
    this.loadingProfile = true;
    this.identity.currentUser.subscribe((user) => (this.currentUser = user));
    this.currentUser = this.userService.getCurrentUser();
    this.rol = this.userService.getCurrentUser();

    this.defineRegistryState();
    this.fechaNacimientoModel = this.currentUser?.persona?.fechaNacimiento;
    this.loggedUser = this.identity.getUser();
    let optionsCollection = await this.userService.getMasterActivities();
    for (var option of optionsCollection) {
      this.rubroOptionsCollection.push(<IOptionsNgSelect>{
        value: option.id,
        display: option.nombre
      });
    }

    try {
      const response = await this.userService.getCommerceByUserId();
      if (response) {
        this.imageService.requestProfileImage(this.currentUser.id).then((r) => {
          this.profilePictureUrl = r;
          this.organism = response;
          this.locationData = Object.assign({}, response.ubicacion);
        });
      } else {
        this.organism = null;
      }
    } catch (error) {
      this.loadingProfile = false;
      this.isGenerated = false;
      this.organism = null;
    }

    try {
      const bankInfo = <AccountInfo>await this.balanceService.cashIn();
      this.isGenerated = bankInfo.cbu !== '' ? true : false;
    } catch (error) {
      console.log(error);
    }

    if (this.currentUser.organismo) {
      this.checked = true;
      this.wantToBeOrganismo = true;
      const token = await this.userService.getTokenCommerce();
      if (token) {
        this.hasApiToken = true;
        this.valueToken = token;
        if (this.valueToken.length / 60 > 1) {
          this.rowTxt += this.valueToken.length / 60;
        }
      }
    }

    setTimeout(() => {
      this.loadFormData();
    }, 500);

    try {
      let userAccount = await this.userService.getUserCVU();

      if (userAccount) {
        this.userCVUAlias = userAccount.cvuAlias;
        this.userCVU = userAccount.cvu;
      }
    } catch (error) {
      this.loadingProfile = false;
      console.log({
        header: '# ngOnInit.getUserVirtualAccount',
        error: error.message
      });
    }

    this.loadingProfile = false;

    if (this.rol.rol.id == 7) {
      this.domicilioFiscal.disable();
      this.comercioRS.disable();
      this.comercioRubro.disable();
      this.condicionIVAform.disable();
    }

    this.loadingProfile = false;
  }

  getStatusButton() {
    return (
      !(this.form.valid && this.checked) ||
      this.placeChanged ||
      this.form.get('departamentoPiso').dirty ||
      this.form.get('departamentoNumero').dirty ||
      this.form.get('comercioNombre').dirty ||
      this.form.get('rubro').dirty
    );
  }

  getProfileStatusButton() {
    return (
      !(this.myform.valid && this.checked) ||
      this.myform.get('nombres').dirty ||
      this.myform.get('apellido').dirty ||
      this.myform.get('fechaNacimiento').dirty ||
      this.myform.get('telefono').dirty ||
      this.myform.get('nacionalidad').dirty ||
      this.myform.get('provincia').dirty ||
      this.myform.get('localidad').dirty ||
      this.myform.get('calle').dirty ||
      this.myform.get('numero').dirty ||
      this.myform.get('piso').dirty ||
      this.myform.get('dpto').dirty ||
      this.myform.get('codigoPostal').dirty ||
      this.myform.get('sexo').dirty
    );
  }

  changeStatusCheck() {
    this.checked = !this.checked;
  }

  changeVisibility() {
    this.visibility = !this.visibility;
  }

  copyToken() {
    if (this.txtToken && this.valueToken) {
      this.txtToken.nativeElement.select();
      document.execCommand('copy');
      this.txtToken.nativeElement.setSelectionRange(0, 0);
      this.notificationService.showSuccess('Código de seguridad copiado en el portapapeles');
    }
  }
  //#region INITIAL-VALUES
  ocult = false;
  loadFormData(initialData: boolean = true): void {
    if (!initialData) {
      this.currentUser = this.userService.getCurrentUser();
    }

    if (this.userHasOrganism) {
      this.addToForm('comercioNombre', this.organism.nombre);
      this.addToForm('domicilioComercial', this.identity.getUser().organismo.ubicacion.nombreDireccion);
      this.addToForm('comercioRS', this.organism.razonSocial);
      this.addToForm('comercioCuit', this.organism.numeroDocumento);
      this.addToForm('domicilioFiscal', this.organism.domicilioFiscal);
      this.addToForm('comercioRubro', this.organism.rubroServicio ?? this.currentUser.organismo.servicioList[0].nombre);
      this.addToForm('apiToken', this.valueToken);
      this.addToForm('departamentoPiso', this.identity.getUser().organismo.ubicacion.piso);
      this.addToForm('departamentoNumero', this.identity.getUser().organismo.ubicacion.departamento);
      this.addToForm('descipcionOptional', this.locationData.descripcion);
      this.addToForm('condicionIVA', this.getCondicionIVALabel(this.organism.condicionIVA));
      this.addToForm('rubro', this.identity.getUser().organismo.rubro.id);
      this.ocult = true;
      if (this.organism.rubro) {
        this.addToForm('rubro', this.organism.rubro.id);
      }
      if (this.locationData.esDepartamento) {
        this.esDepartamento = true;
        this.selectHomeType = this.TIPO_DEPARTAMENTO;
      }
      this.cuitReadonly = true;
    }
  }

  private getCondicionIVALabel(code: string): string {
    switch (code) {
      case 'EXENTO':
        return 'Exento';
      case 'MONOTRIBUTISTA':
        return 'Monotributista';
      case 'RESP_INSCRIPTO':
        return 'Responsable Inscripto';
      default:
        return 'Consultando en AFIP...';
    }
  }

  resetControl(control: string): void {
    this.form.get(control).reset();
  }

  addToForm(input: string, value: any): void {
    this.form.get(input).setValue(value);
  }

  defineRegistryState(): void {
    let result = <RegistryInformation>{};

    if (
      (this.currentUser?.organismo && this.currentUser?.organismo.rubro) ||
      this.currentUser?.statusRegistro.complete
    ) {
      result.colorClass = 'color_primary';
      result.icon = 'check_circle_outline';
      result.text = this.translate('pages.profile.messages.reg_complete');
    } else {
      result.colorClass = 'color_red';
      result.icon = 'cancel';
      result.text = this.translate('pages.profile.messages.reg_incomplete');
    }

    this.registryState = result;
  }

  selectedPlaceEventHandler(place: GenericPlace | null): void {
    this.placeChanged = true;
    if (place) {
      this.form.get(this.DOMICILIO_COMERCIAL).setValue(place.nombreDireccion);
    } else {
      this.form.get(this.DOMICILIO_COMERCIAL).reset();
    }
    this.ref.detectChanges();
  }

  //#endregion INITIAL-VALUES

  //create and save organism

  async savePersonalProfile(form) {
    if (this.myform.valid) {
      try {
        this.saving = true;
        const response = await this.userService.savePersonalProfile(
          form.email,
          form.dni,
          form.telefono,
          form.cuilCuit,
          form.apellido,
          form.nombres,
          form.fechaNacimiento,
          form.sexo,
          form.nacionalidad,
          form.localidad,
          form.provincia,
          form.calle,
          form.numero,
          form.piso,
          form.dpto,
          form.codigoPostal
        );
      } catch (error) {
        this.notificationService.showError(error.message);
      }
      this.saving = false;
      window.location.reload();
    }
  }
  async createAndSaveOrganism(form) {
    if (this.form.valid) {
      let id: number = this.organismId;

      if (this.searchPlace.isPresent() && this.searchPlace.get() != null) {
        this.locationData = this.searchPlace.get();
        if (this.organism != null && this.organism.ubicacion != null) {
          this.locationData.id = this.organism.ubicacion.id;
        }
      }
      this.locationData.esDepartamento = true;

      if (form.departamentoPiso !== '' && form.departamentoNumero !== '') {
        this.locationData.esDepartamento = true;
        this.locationData.departamento = form.departamentoNumero;
        this.locationData.piso = form.departamentoPiso;
      } else {
        this.locationData.esDepartamento = false;
        form.departamentoPiso = '';
        form.departamentoNumero = '';
        this.locationData.departamento = null;
        this.locationData.piso = null;
      }

      this.locationData.descripcion = form.descipcionOptional;

      try {
        this.saving = true;
        const response = await this.userService.saveOrganismsProfile(
          id,
          form.comercioNombre,
          form.comercioRS,
          form.domicilioFiscal,
          form.bancoForm != null ? form.bancoForm : '',
          form.comercioCuit,
          null,
          form.comercioRubro,
          this.afipData,
          this.locationData,
          +form.rubro
        );
        if (response) {
          this.organism = response;
          this.loadFormData(false);
        }
        this.form.markAsPristine();
        this.currentUser.organismo = this.organism;
        this.identity.saveUser(this.currentUser);
        this.defineRegistryState();
        this.notificationService.showSuccess(this.translate('pages.profile.messages.update_success'));
        if (this.identity.getUser().organismo.ubicacion.provincia != 'Mendoza') {
          //si no es de mendoza le damos de baja el medio de pago caja plus
          this.tarifarioService.subscribeTarifario(false, [40]);
        }
        window.location.reload();
        this.saving = false;
      } catch (error) {
        this.notificationService.showError(error.message);
      }
    }
  }

  async openDialogAndSave(form) {
    if (!this.userHasOrganism) {
      this.dialogCommerce = this.dialog.open(DialogCommerceComponent, {
        data: {
          confirmation: true
        }
      });
      this.dialogCommerce.afterClosed().subscribe(async (result) => {
        if (result) {
          this.saving = true;
          await this.createAndSaveOrganism(form);
          this.saving = false;
        }
      });
    } else {
      this.saving = true;
      await this.createAndSaveOrganism(form);
      this.saving = false;
    }
  }

  async onSubmitHandler(form: CommerceForm): Promise<void> {
    try {
      this.openDialogAndSave(form);
    } catch (error) {
      this.dialog.open(DialogAfipComponent, {
        width: '600px',
        data: {
          error: finalDotVerificator(error.message),
          title: this.translate('commons.labels.atention')
        }
      });
    }
  }

  get loggedUserIsResponsible(): boolean {
    return this.identity.hasRolId(RolesWeb.RESPONSABLE);
  }

  getErrorMessage(valueError: number) {
    switch (valueError) {
      case 1:
        return this.formControls.apellido.hasError('required')
          ? this.translate('commons.errors.required', 'pages.profile.labels.surname')
          : '';
      case 2:
        return this.formControls.nombre.hasError('required')
          ? this.translate('commons.errors.required', 'pages.profile.labels.name')
          : '';
      case 3:
        return this.formControls.nroDocumento.hasError('required')
          ? this.translate('commons.errors.required', 'pages.profile.labels.doc')
          : '';
      case 4:
        return this.formControls.fechaNacimiento.hasError('required')
          ? this.translate('commons.errors.required', 'pages.profile.labels.birthdate')
          : '';
      case 5:
        return this.formControls.comercioRubro.hasError('required')
          ? this.translate('commons.errors.required', 'pages.profile.labels.service_category')
          : '';
      case 6:
        return this.formControls.comercioCuit.hasError('required')
          ? this.translate('commons.errors.required', 'pages.profile.labels.cuit')
          : '';
      case 8:
        return this.formControls.comercioRS.hasError('required')
          ? this.translate('commons.errors.required', 'pages.profile.labels.business_name')
          : '';
      case 9:
        return this.formControls.domicilioFiscal.hasError('required')
          ? this.translate('commons.errors.required', 'pages.profile.labels.legal_address')
          : '';
      case 10:
        return this.formControls.domicilioComercial.hasError('required')
          ? this.translate('commons.errors.required', 'pages.profile.labels.address')
          : '';
      case 11:
        return this.formControls.comercioNombre.hasError('required')
          ? this.translate('commons.errors.required', 'pages.profile.labels.fantasy_name')
          : '';
      case 12:
        return this.translate('pages.profile.messages.errors.invalid_cuit');
      case 13:
        return this.formControls.condicionIVAform.hasError('required')
          ? this.translate('commons.errors.required', 'pages.profile.labels.iva_treatment')
          : '';
      case 14:
        return this.formControls.rubro.hasError('required')
          ? this.translate('commons.errors.required', 'pages.profile.labels.activity')
          : '';
      default:
        return '';
    }
  }

  onKeyPressEvent(event): boolean {
    const charCode = event.which ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;
  }

  cleanAfipFields(buttonPressed: boolean = false): void {
    buttonPressed ? this.form.controls['comercioCuit'].reset() : null;
    this.resetControl('comercioRS');
    this.resetControl('domicilioFiscal');
    this.resetControl('comercioRubro');
  }

  cleanCommerceName(buttonPressed: boolean = false): void {
    buttonPressed ? this.form.controls['comercioNombre'].reset() : null;
  }

  cleanDepartmentNumber(buttonPressed: boolean = false): void {
    buttonPressed ? this.form.controls['departamentoNumero'].reset() : null;
  }

  cleanDepartamentoPiso(buttonPressed: boolean = false): void {
    buttonPressed ? this.form.controls['departamentoPiso'].reset() : null;
  }

  cleanLocaltionInputHandler(buttonPressed: boolean = false): void {
    buttonPressed
      ? (this.form.controls['domicilioComercial'].reset(), this.form.controls['domicilioComercial'].setValue(''))
      : null;
  }

  cuitFormatter(cuit: string) {
    let first = cuit.substring(0, 2);
    let dni = cuit.substring(3, 11);
    let end = cuit.substring(12, 13);
    return `${first}${dni}${end}`;
  }

  async cuitInputEventHandler(value: string): Promise<void> {
    let cuit = this.cuitFormatter(value);
    if (cuit.length == 11) {
      if (validateCuit(cuit)) {
        this.searchingCuit = true;
        this.cuitReadonly = true;
        try {
          const afipResponse = await this.afipService.validateCuit(cuit);
          this.addToForm('comercioRS', afipResponse.razonSocial);
          this.addToForm('domicilioFiscal', afipResponse.domicilioFiscal);
          this.addToForm('comercioRubro', afipResponse.actividad);
          this.addToForm('condicionIVA', this.getCondicionIVALabel(''));

          this.afipData = afipResponse;

          this.hideCuitErrors();
        } catch (errorAfip) {
          this.dialog.open(DialogAfipComponent, {
            width: '600px',
            data: {
              error: finalDotVerificator(errorAfip),
              title: this.translate('pages.profile.messages.errors.cuit_validation')
            }
          });
        }
        this.searchingCuit = false;

        if (!this.userHasOrganism) {
          this.cuitReadonly = false;
        }
      } else {
        this.displayCuitErrorMessage = true;
        this.formControls.comercioCuit.setErrors({ incorrect: true });
      }
    } else {
      this.displayCuitErrorMessage = false;
      this.cleanAfipFields();
      this.hideCuitErrors();
    }
  }

  hideCuitErrors(): void {
    this.formControls.comercioCuit.setErrors({});
    this.formControls.comercioCuit.updateValueAndValidity();
  }

  nacionalidades = [
    { nombre: 'Argentina', code: 'Argentina' },
    { nombre: 'Bolivia', code: 'Bolivia' },
    { nombre: 'Brasil', code: 'Brasil' },
    { nombre: 'Chile', code: 'Chile' },
    { nombre: 'Colombia', code: 'Colombia' },
    { nombre: 'Costa Rica', code: 'Costa Rica' },
    { nombre: 'Cuba', code: 'Cuba' },
    { nombre: 'República Dominicana', code: 'República Dominicana' },
    { nombre: 'Ecuador', code: 'Ecuador' },
    { nombre: 'El Salvador', code: 'El Salvador' },
    { nombre: 'Guatemala', code: 'Guatemala' },
    { nombre: 'Honduras', code: 'Honduras' },
    { nombre: 'México', code: 'México' },
    { nombre: 'Nicaragua', code: 'Nicaragua' },
    { nombre: 'Panamá', code: 'Panamá' },
    { nombre: 'Paraguay', code: 'Paraguay' },
    { nombre: 'Perú', code: 'Perú' },
    { nombre: 'Uruguay', code: 'Uruguay' },
    { nombre: 'Venezuela', code: 'Venezuela' },
    { nombre: 'Australia', code: 'Australia' },
    { nombre: 'Canadá', code: 'Canadá' },
    { nombre: 'Estados Unidos', code: 'Estados Unidos' },
    { nombre: 'Reino Unido', code: 'Reino Unido' },
    { nombre: 'Otra', code: 'Otra' }
  ];
  provincias = [
    { nombre: 'Buenos Aires', code: 1 },
    { nombre: 'Capital Federal', code: 2 },
    { nombre: 'Catamarca', code: 3 },
    { nombre: 'Cordoba', code: 4 },
    { nombre: 'Corrientes', code: 5 },
    { nombre: 'Chaco', code: 6 },
    { nombre: 'Chubut', code: 7 },
    { nombre: 'Entre Rios', code: 8 },
    { nombre: 'Formosa', code: 9 },
    { nombre: 'Jujuy', code: 10 },
    { nombre: 'La Pampa', code: 11 },
    { nombre: 'La Rioja', code: 12 },
    { nombre: 'Mendoza', code: 13 },
    { nombre: 'Misiones', code: 14 },
    { nombre: 'Neuquen', code: 15 },
    { nombre: 'Rio Negro', code: 16 },
    { nombre: 'Salta', code: 17 },
    { nombre: 'San Juan', code: 18 },
    { nombre: 'San Luis', code: 19 },
    { nombre: 'Santa Cruz', code: 20 },
    { nombre: 'Santa Fe', code: 21 },
    { nombre: 'Santiago del Estero', code: 22 },
    { nombre: 'Tucuman', code: 23 },
    { nombre: 'Tierra del Fuego', code: 24 }
  ];

  trimValue(value: string, controler: any) {
    value = value.trim();
    if (value == '') {
      controler.setValue(null);
    }
  }

  isResponsible() {
    return this.currentUser.isResponsible;
  }

  deleteUser() {
    const dialog = this.dialog.open(DeleteAccountComponent, {
      width: '400px'
    });

    dialog.afterClosed().subscribe((accountDeleted) => {
      if (accountDeleted) {
        this.login.endSession();
      }
    });
  }

  cambiarTipoCasa() {
    this.form.controls.departamentoPiso.clearValidators();
    this.form.controls.departamentoPiso.updateValueAndValidity();
    this.selectHomeType = this.TIPO_CASA;
  }

  cambiarTipoDepartamento() {
    this.selectHomeType = this.TIPO_DEPARTAMENTO;
    this.form.controls.departamentoPiso.setValidators([Validators.required]);
    this.form.controls.departamentoPiso.updateValueAndValidity();
  }

  isEmptyFieldAndHasOrganism(data: string) {
    return data === '-' && this.userHasOrganism;
  }

  isEmptyColumnAndHasOrganism() {
    var ud = this.userDocument;
    var un = this.userName;
    var ub = this.userBirth;

    return ud === '-' && un === '-' && ub === '-' && this.userHasOrganism;
  }

  closeCommerceForm() {
    this.wantToBeOrganismo = false;
    this.form.reset();
  }

  goToCvuView(url: string) {
    let currentUrl = this.router.url;
    localStorage.setItem('url', currentUrl);
    this.navigate(url);
  }

  goToQr(url: string) {
    let currentUrl = this.router.url;
    localStorage.setItem('url', currentUrl);
    this.navigate(url);
  }

  navigate(url: string) {
    this.router.navigate([url]);
  }

  openTyCPopup() {
    this.dialog.open(TermsAndConditionsDialogComponent, {
      data: {
        mustAcceptTermsAndConditions: false
      }
    });
  }
}

interface RegistryInformation {
  icon: string;
  colorClass: string;
  text: string;
}

interface AccountInfo {
  alias: string;
  cbu: string;
  ingresoRapipago: boolean;
  tipoCuenta: string;
}
